import { nextTick } from 'vue';
import { WORKFLOW_VARIABLE_DRAG_TYPE } from './workflowFlowVariableCatalog';

/** Permite largar variáveis do fluxo em inputs de texto / textarea (arrastar do painel lateral). */
export const workflowVariableDrop = {
  mounted(el, binding) {
    const opts =
      binding.value && typeof binding.value === 'object' ? binding.value : {};

    const onDragOver = e => {
      if (opts.disabled) return;
      e.preventDefault();
      e.dataTransfer.dropEffect = 'copy';
    };

    const onDrop = e => {
      if (opts.disabled) return;
      e.preventDefault();
      const token =
        e.dataTransfer.getData(WORKFLOW_VARIABLE_DRAG_TYPE) ||
        e.dataTransfer.getData('text/plain');
      if (!token || !String(token).trim()) return;
      if (el.disabled || el.readOnly) return;

      const prev = el.value;
      const start =
        typeof el.selectionStart === 'number' ? el.selectionStart : prev.length;
      const end =
        typeof el.selectionEnd === 'number' ? el.selectionEnd : prev.length;
      const next = `${prev.slice(0, start)}${token}${prev.slice(end)}`;
      el.value = next;

      el.dispatchEvent(new InputEvent('input', { bubbles: true }));

      nextTick(() => {
        el.focus();
        const pos = start + token.length;
        try {
          el.setSelectionRange(pos, pos);
        } catch {
          /* password ou inputs sem seleção */
        }
      });
    };

    el.__wfVarDrop_onDragOver = onDragOver;
    el.__wfVarDrop_onDrop = onDrop;
    el.addEventListener('dragover', onDragOver);
    el.addEventListener('drop', onDrop);
  },

  unmounted(el) {
    if (el.__wfVarDrop_onDragOver) {
      el.removeEventListener('dragover', el.__wfVarDrop_onDragOver);
    }
    if (el.__wfVarDrop_onDrop) {
      el.removeEventListener('drop', el.__wfVarDrop_onDrop);
    }
    delete el.__wfVarDrop_onDragOver;
    delete el.__wfVarDrop_onDrop;
  },
};
